<template>
  <section class="seltos-zhijia-page">
    <BasicVideoPicsTextSwiper :title="title" :text="text" :subtitle="subtitle" :imgs="imgs" id="10"></BasicVideoPicsTextSwiper>
  </section>
</template>
<script>
import BasicVideoPicsTextSwiper from '@/components/basic-videopicstext-swiper-new-zhijia.vue'
export default {
  data() {
    return {
      title: '智泊无界 ',
      subtitle:'尖端「芯」智',
      imgs: [

        {
          imgPC: 'https://www.kia.cn/assets/~/media/images/vehicle/newseltos/drive/pc-2/fca.jpg',
          imgMob: 'https://www.kia.cn/assets/~/media/images/vehicle/newseltos/drive/mob-2/fca.jpg',
          videoPc: 'https://img.kia.cn/media/videos/202608/caozuo/2026080301.mp4',
          videoMob: 'https://img.kia.cn/media/videos/202608/caozuo/2026080301.mp4',
          posterPc: 'https://www.kia.cn/assets/~/media/images/vehicle/newseltos/drive/pc-2/zhijia1fegnmian.jpg',
          posterMob: 'https://www.kia.cn/assets/~/media/images/vehicle/newseltos/drive/pc-2/zhijia1fegnmian.jpg',
          title: '前方防止碰撞辅助(FCA1.5)',
          text: '*（车辆 / 行人 / 两轮车 / 交叉路对向车 / 正面对向车）',
          type: 'img' 
        },
        {
          imgPC: 'https://www.kia.cn/assets/~/media/images/vehicle/newseltos/drive/pc-2/zhijia2.jpg',
          imgMob: 'https://www.kia.cn/assets/~/media/images/vehicle/newseltos/drive/mob-2/zhijia2.jpg',
          videoPc: 'https://img.kia.cn/content/videos/20230821/ev5_clear.mp4',
          videoMob: 'https://img.kia.cn/content/videos/20230821/ev5_clear.mp4',
          posterPc: 'https://uat.kia.cn/assets/~/media/images/vehicle/ev5/vehicle/experience/img1.png',
          posterMob: 'https://uat.kia.cn/assets/~/media/images/vehicle/ev5/vehicle/experience/img1.png',
          title: '车道保持辅助(LFA2)',
          // text: '（含前排中置安全气囊）',
          type: 'img'
        },
        {
          imgPC: 'https://www.kia.cn/assets/~/media/images/vehicle/newseltos/drive/pc-2/nscc.jpg',
          imgMob: 'https://www.kia.cn/assets/~/media/images/vehicle/newseltos/drive/mob-2/nscc.jpg',
          videoPc: 'https://img.kia.cn/content/videos/20230821/ev5_clear.mp4',
          videoMob: 'https://img.kia.cn/content/videos/20230821/ev5_clear.mp4',
          posterPc: 'https://uat.kia.cn/assets/~/media/images/vehicle/ev5/vehicle/experience/img1.png',
          posterMob: 'https://uat.kia.cn/assets/~/media/images/vehicle/ev5/vehicle/experience/img1.png',
          title: '基于导航智能巡航控制-直线/弯道(NSCC-Z/C)',
          // text: '（含前排中置安全气囊）',
          type: 'img'
        },
        {
          imgPC: 'https://www.kia.cn/assets/~/media/images/vehicle/newseltos/drive/pc-2/zhijia5.jpg',
          imgMob: 'https://www.kia.cn/assets/~/media/images/vehicle/newseltos/drive/mob-2/zhijia5.jpg',
          videoPc: 'https://img.kia.cn/content/videos/20230821/ev5_clear.mp4',
          videoMob: 'https://img.kia.cn/content/videos/20230821/ev5_clear.mp4',
          posterPc: 'https://uat.kia.cn/assets/~/media/images/vehicle/ev5/vehicle/experience/img3.png',
          posterMob: 'https://uat.kia.cn/assets/~/media/images/vehicle/ev5/vehicle/experience/img3.png',
          title: '泊车距离警告-前/侧/后(PDW-F/S/R)<br>' +
            '泊车防止碰撞辅助-后方(PCA-R)',
          text: "",
          type: 'img'
        },
        {
          imgPC: 'https://www.kia.cn/assets/~/media/images/vehicle/newseltos/drive/pc-2/zhijia1.jpg',
          imgMob: 'https://www.kia.cn/assets/~/media/images/vehicle/newseltos/drive/mob-2/zhijia1.jpg',
          videoPc: 'https://img.kia.cn/media/videos/202608/caozuo/2026080301.mp4',
          videoMob: 'https://img.kia.cn/media/videos/202608/caozuo/2026080301.mp4',
          posterPc: 'https://www.kia.cn/assets/~/media/images/vehicle/newseltos/drive/pc-2/zhijia1fegnmian.jpg',
          posterMob: 'https://www.kia.cn/assets/~/media/images/vehicle/newseltos/drive/pc-2/zhijia1fegnmian.jpg',
          title: '遥控智能泊车辅助(RSPA)',
          // text: '（含前排中置安全气囊）',
          type: 'video'
        },
        {
          imgPC: 'https://www.kia.cn/assets/~/media/images/vehicle/newseltos/drive/pc-2/zhijia3.jpg',
          imgMob: 'https://www.kia.cn/assets/~/media/images/vehicle/newseltos/drive/mob-2/zhijia3.jpg',
          videoPc: 'https://img.kia.cn/content/videos/20230821/ev5_clear.mp4',
          videoMob: 'https://img.kia.cn/content/videos/20230821/ev5_clear.mp4',
          posterPc: 'https://uat.kia.cn/assets/~/media/images/vehicle/ev5/vehicle/experience/img3.png',
          posterMob: 'https://uat.kia.cn/assets/~/media/images/vehicle/ev5/vehicle/experience/img3.png',
          title: '全景显示(SVM)',
          //text: "通过控制加速踏板实现加速、减速、停车的单踏板模式",
          type: 'img'
        },
        {
          imgPC: 'https://www.kia.cn/assets/~/media/images/vehicle/newseltos/drive/pc-2/zhijia4.jpg',
          imgMob: 'https://www.kia.cn/assets/~/media/images/vehicle/newseltos/drive/mob-2/zhijia4.jpg',
          videoPc: 'https://img.kia.cn/content/videos/20230821/ev5_clear.mp4',
          videoMob: 'https://img.kia.cn/content/videos/20230821/ev5_clear.mp4',
          posterPc: 'https://uat.kia.cn/assets/~/media/images/vehicle/ev5/vehicle/experience/img3.png',
          posterMob: 'https://uat.kia.cn/assets/~/media/images/vehicle/ev5/vehicle/experience/img3.png',
          title: '7安全气囊',
          text: "*（前排双气囊 / 前排侧气囊 / 前排中置气囊 / 侧气帘）",
          type: 'img'
        }
      ],
    }
  },
  components: {
    BasicVideoPicsTextSwiper
  },
  mounted() {
  }
}
</script>
<style>
.seltos-zhijia-page {
  background: #D5D6D8;
}
.seltos-zhijia-page .title-outer .sub-title {
  /* font-size: 2.083333vw !important;
  font-weight: 600;
  line-height: 1.8875vw; */
}
.seltos-zhijia-page .title-outer .sub-title-mob {
  /* font-size: calc(22/375*100vw) !important;
  font-weight: 600;
  line-height: 2.1875vw; */
}
.seltos-zhijia-page .swiper-slide-mob {
  /* background-color: #D5D6D8 !important; */
}
</style>
